var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('p',{staticClass:"page_title"},[_vm._v("404 page not found")]),_c('button',{staticStyle:{"margin-top":"30px","padding":"5px"},on:{"click":_vm.JumpHome}},[_vm._v("返回首页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }